/* --------------------
 * react-async-ssr module
 * Symbols
 * ------------------*/

'use strict';

// Exports

module.exports = {
	NO_SSR: '$_react-async-ssr/symbols.NO_SSR',
	ABORT: '$_react-async-ssr/symbols.ABORT',
	ON_MOUNT: '$_react-async-ssr/symbols.ON_MOUNT'
};
